export const notificationConfigs = [
  {
    title: 'Bài viết',
    description: 'Gửi thông báo khi có bài viết tới'
  }
]
